/** The yard's phone surface: the trucks due back, and one screen to receive each. */
export const YARD_PATH = '/yard';

export function receiveTruckPath(tripId: string): string {
  return `${YARD_PATH}/receive/${tripId}`;
}
